import React from 'react';
import { BsArrowsFullscreen, BsBadge3D } from 'react-icons/bs';
import { PiCubeFill } from 'react-icons/pi';
import { ImPrinter } from 'react-icons/im';
import { FaSlidersH } from 'react-icons/fa';

export function iconFullScreen() {
  return (
    <div className="px-1">
      <BsArrowsFullscreen
        className="text-gray-400"
        size={16}
      />
    </div>
  );
}
export function icon3DSelector() {
  return (
    <div className="p-[2px]">
      <BsBadge3D
        className="text-white opacity-80"
        size={18}
      />
    </div>
  );
}
export function iconToolMPR() {
  return (
    <div className="p-[2px]">
      <PiCubeFill
        className="text-white opacity-80"
        size={20}
      />
    </div>
  );
}
export function iconDicomPrint() {
  return (
    <div className="p-[2px]">
      <ImPrinter
        className="text-white opacity-80"
        size={20}
      />
    </div>
  );
}
export function intensityIcon() {
  return (
    <div className="p-[2px]">
      <FaSlidersH
        className="text-white opacity-80"
        size={16}
      />
    </div>
  );
}
